import { useSnapshot } from 'valtio';

import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import HelpIcon from '@cartwhl/ui/icons/HelpIcon';
import KeyboardIcon from '@cartwhl/ui/icons/KeyboardIcon';
import LinkIcon from '@cartwhl/ui/icons/LinkIcon';
import MailIcon from '@cartwhl/ui/icons/MailIcon';
import Button from '@cartwhl/ui/input/Button';

import { userStore } from 'stores/global';

interface MotionEditorHelpMenuProps {
  onOpenHotkeys: () => void;
}

export default function MotionEditorHelpMenu({
  onOpenHotkeys,
}: MotionEditorHelpMenuProps) {
  const { userInfo } = useSnapshot(userStore.state);
  const supportText =
    userInfo.planType === 'free' ? 'Contact support' : 'Advanced support';
  const mailtoAddress =
    userInfo.planType === 'free'
      ? 'support@getcartwheel.com'
      : 'pros@getcartwheel.com';

  return (
    <div className="hidden h-full items-center justify-end md:flex">
      <Dropdown
        trigger={
          <Button
            variant="secondary"
            size="sm"
            icon={<HelpIcon />}
            alignIcon="end"
          >
            Help
          </Button>
        }
      >
        <Dropdown.Item href="https://discord.gg/TQS278evHH" icon={<LinkIcon />}>
          Help on Discord
        </Dropdown.Item>
        <Dropdown.Item
          icon={<MailIcon />}
          href={`mailto:${mailtoAddress}?subject=Help%20with%20Motion%20Editor`}
        >
          {supportText}
        </Dropdown.Item>
        <Dropdown.Item icon={<KeyboardIcon />} onClick={onOpenHotkeys}>
          Hotkeys
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
}
